import React, { useCallback, useEffect, useState } from 'react'
import SidePanel from '../../../../ui/SidePanel/SidePanel'
import Spinner from '../../../../ui/Spinner/Spinner'
import { isNull } from 'lodash'
import { withRouter } from 'react-router-dom'
import getCollection from '../../../../utils/db/getCollection'
import './PagesList.sass'

function PagesList({ routerIdName, onClickPath, ...router }) {
  const [pages, setPages] = useState(null)
  const pageId = router.match.params[routerIdName]
  // const [bannerManagerState, setBannerManagerState] = useState({
  //   type: null,
  //   bannerId: null,
  // })

  useEffect(() => {
    getCollection({
      path: 'settings/pages/list',
      docIdName: 'id',
    }).then((res) => setPages(res))
  }, [])

  const onClick = useCallback(
    (id) => {
      router.history.push(`${onClickPath}/${id}`)
    },
    [onClickPath, router.history]
  )

  useEffect(() => {
    if (!pageId && !isNull(pages)) {
      onClick(pages[0].id)
    }
  }, [pageId, pages, onClick])

  // const onBannerManagerClose = () => {
  //   setBannerManagerState({
  //     type: null,
  //     bannerId: null,
  //   })
  // }

  // const onSortEnd = ({ oldIndex, newIndex }) => {
  //   const neBanners = arrayMove(banners, oldIndex, newIndex)
  //   setBanners(neBanners)
  // }

  // const updateBannersOrder = () => {
  //   setIsLoading(true)
  //   Promise.all(
  //     banners.map((b, i) =>
  //       updateDoc({
  //         path: 'settings/banners/list',
  //         docId: b.id,
  //         data: { pos: i },
  //       }),
  //     ),
  //   )
  //     .then(() => setIsLoading(false))
  //     .catch(() => {
  //       console.log('error')
  //     })
  // }

  return (
    <>
      {/* {bannerManagerState.type === 'add' && (
        <BannerManager onClose={onBannerManagerClose} />
      )} */}
      <SidePanel
        title="Текстова інформація"
        content={
          <div className="PagesList-Container">
            {!isNull(pages) ? (
              pages.map((p) => (
                <div className={`Page ${pageId === p.id && 'Page_theme_active'} `} onClick={() => onClick(p.id)}>
                  {p.name}
                </div>
              ))
            ) : (
              <Spinner type="popup" />
            )}
          </div>
        }
        // buttons={
        //   <>
        //     <Button
        //       theme="circle"
        //       fill="white"
        //       icon="list-ol"
        //       isLoading={isLoading}
        //       onClick={updateBannersOrder}
        //     />
        //     <Button theme="circle" fill="accent" icon="plus" onClick={onAdd} />
        //   </>
        // }
      />
    </>
  )
}

export default withRouter(PagesList)
